import { Component } from '@angular/core';
import { NavController, NavParams, ViewController} from 'ionic-angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'page-info-modal',
  templateUrl: 'info-modal.html',
})
export class InfoModalPage {

  title = 'Informatie';
  text = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    public viewCtrl: ViewController
  ) {
    this.title = this.translate.instant('Informatie');
    if(this.navParams.get('title')) this.title = this.translate.instant(this.navParams.get('title'));
    if(this.navParams.get('text')) this.text = this.translate.instant(this.navParams.get('text'));
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoModalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/info-modal/info-modal.ts